import { render, staticRenderFns } from "./UserEditForm.vue?vue&type=template&id=246b5c50"
import script from "./UserEditForm.vue?vue&type=script&lang=js"
export * from "./UserEditForm.vue?vue&type=script&lang=js"
import style0 from "./UserEditForm.vue?vue&type=style&index=0&id=246b5c50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports